import { useEffect, useState } from 'react';
import RightSidebar from './Sidebar/RightSidebar';
import { CategoryModal } from './utils/enums';
import { CategoryView } from './Sidebar/CategoryView';
import styles from '@/styles/documents.module.css';
import ModalAddCategory from './Modals/ModalAddCategory';
import ModalEditCategory from './Modals/ModalEditCategory';
import ModalDeleteCategory from './Modals/ModalDeleteCategory';
import { Category } from '@/types/categories/category';
import Footer from '@/components/Footer';

export default function Categories({ setReloadData }: any) {
  const [count, setCount] = useState<number>(0);
  const [categoryView] = useState(
    () =>
      new CategoryView(() => {
        setCount(prev => prev + 1);
        setReloadData((prev: boolean) => !prev);
      }),
  );
  const [currentCategory, setCurrentCategory] = useState<Category | null>(null);
  const [openModal, setOpenModal] = useState<CategoryModal | null>(null);

  useEffect(() => {
    const initCategories = async () => {
      await categoryView.init();
    };
    initCategories();
  }, [categoryView]);

  const handleRefresh = async () => {
    await categoryView.refresh();
  };

  return (
    <div className={styles?.documents} style={{ padding: '20px', flexDirection: 'column' }}>
      <div style={{ flex: 1, overflow: 'auto' }}>
        <RightSidebar
          categoryView={categoryView}
          currentCategory={currentCategory}
          setCurrentCategory={setCurrentCategory}
          setOpenModal={setOpenModal}
        />
      </div>
      <Footer />
      <ModalAddCategory
        open={openModal === CategoryModal.ADD}
        onOk={() => setOpenModal(null)}
        onCancel={() => setOpenModal(null)}
        onLoadData={handleRefresh}
      />
      <ModalEditCategory
        category={currentCategory}
        open={openModal === CategoryModal.EDIT}
        onOk={() => setOpenModal(null)}
        onCancel={() => {
          setOpenModal(null);
          setCurrentCategory(null);
        }}
        onLoadData={handleRefresh}
      />
      <ModalDeleteCategory
        category={currentCategory}
        open={openModal === CategoryModal.DELETE}
        onCancel={() => {
          setOpenModal(null);
          setCurrentCategory(null);
        }}
        onLoadData={handleRefresh}
      />
    </div>
  );
}
